import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=b8c8f332&scoped=true"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=b8c8f332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c8f332",
  null
  
)

export default component.exports